/* Mochi's World: reveal-on-scroll for [data-mf-reveal]. IntersectionObserver only, no scroll listeners. */
(function () {
  var els = document.querySelectorAll('[data-mf-reveal]');
  if (!els.length) return;
  var reduce = window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (reduce || !('IntersectionObserver' in window)) {
    els.forEach(function (el) { el.classList.add('is-in'); });
    return;
  }
  var io = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (e.isIntersecting) { e.target.classList.add('is-in'); io.unobserve(e.target); }
    });
  }, { rootMargin: '0px 0px -8% 0px', threshold: 0.15 });
  els.forEach(function (el) { io.observe(el); });
})();
